/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { DomainStore } from 'src/luis/types/stores/domains/DomainStore';
import { DomainStoreHouse } from 'src/luis/types/stores/domains/DomainStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an domain store house,
 * which houses an array of domain stores.
 */
export const createDomainStoreHouse = (): DomainStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<DomainStore>();

    const domainStoreHouse: SubtractStore<DomainStoreHouse, ResourceStoreHouse<DomainStore>> = {
        /**
         * Finds an domain by the given name and returns undefined
         * if not found.
         *
         * @param name The name to search with.
         * @returns The domain or undefined if not found.
         */
        findByName(name: string): DomainStore {
            return this.items.find(i => i.name === name);
        }
    };

    return extendObservable(resourcesStoreHouse, domainStoreHouse, { findByName: action }, { deep: false });
};
